// extracted by mini-css-extract-plugin
module.exports = {"section":"M_section__H5E6j"};